import moment, { Moment } from 'moment'
import React from 'react'
import { FormControl } from 'react-bootstrap'

type TDateInput = {
  start: Moment
  end: Moment
  startTime: Moment
  endTime: Moment
  isRange: boolean
  timepicker: boolean
}

const DateInput = (props: TDateInput): React.ReactElement => {
  const { start, end, startTime, endTime, isRange, timepicker } = props

  let textStart = moment(start).format('DD.MM.YYYY')
  let textEnd = moment(end).format('DD.MM.YYYY')

  if (timepicker) {
    textStart += ` ${moment(startTime).format('HH:mm')}`
    textEnd += ` ${moment(endTime).format('HH:mm')}`
  }

  return (
    <div className="d-flex justify-content-between">
      <div className="flex-fill mx-2 my-0">
        <FormControl
          disabled
          value={
            start && start.isValid()
              ? textStart
              : (i18n.t(
                  `choose_first_day`,
                  `Bitte den ersten Tag auswählen`,
                ) as string)
          }
        />
      </div>
      {isRange && (
        <div className="flex-fill mx-2 my-0">
          <FormControl
            disabled
            value={
              end && end.isValid()
                ? textEnd
                : (i18n.t(
                    'choose_last_date',
                    `Bitte den letzten Tag auswählen`,
                  ) as string)
            }
          />
        </div>
      )}
    </div>
  )
}

export default DateInput
